import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApThemeService } from '@ap/theme';

import { ImageBrand, ImageSearchResponse } from './background-theme.model';
import { defaultImageSearchParameters } from './background-theme.constants';

@Injectable({
    providedIn: 'root'
})
export class BackgroundThemeService {
    public constructor(
        private readonly httpClient: HttpClient,
        private readonly themeService: ApThemeService
    ) {}

    public getBackgroundTheme(name: string): Observable<ImageSearchResponse> {
        const searchParameters = defaultImageSearchParameters;
        searchParameters.search.wmamodularcontent0frontend_image0key = name;
        searchParameters.search.wmamodularcontent0frontend_image0brand = this.getBrandFromTheme();

        const httpHeaders = new HttpHeaders().set('Accept', 'application/json');
        return this.httpClient.post<ImageSearchResponse>(`/searchretrieve/v1/json`, searchParameters, { headers: httpHeaders });
    }

    private getBrandFromTheme(): ImageBrand {
        switch (this.themeService.getTheme()) {
            case 'asn':
                return ImageBrand.ASN;
            case 'sns':
                return ImageBrand.SNS;
            case 'reb':
                return ImageBrand.REB;
            case 'blg':
                return ImageBrand.BLG;
        }
        return ImageBrand.SNS;
    }
}
